<template>
  <v-row justify="center" dense>
    <v-col cols="12" sm="6" md="3">
      <v-select
        :items="transportTypes"
        item-text="name"
        item-value="id"
        v-model="contextTransportType"
        :error-messages="modelTransportTypeValidation"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      >
      </v-select>
    </v-col>
    <v-col cols="12" sm="6" md="3" v-if="modelTransportType !== 1">
      <v-select
        :items="settlementTypes(modelTransportType)"
        v-model="contextSettlementTypeId"
        :error-messages="modelSettlementTypeIdValidation"
        :label="$t('delegation.form.fields.transport.settlementType.name')"
        :readonly="$store.state.Delegation.readonly === true"
      >
      </v-select>
    </v-col>
    <v-col cols="8" sm="4" md="3">
      <AmountInput :error-messages="modelAmountValidation" :model.sync="contextAmount" :readonly="$store.state.Delegation.readonly === true" />
    </v-col>
    <v-col cols="4" sm="2" md="3">
      <currency-select :model.sync="contextCurrency" :validation-message="modelCurrencyValidation" :readonly="$store.state.Delegation.readonly === true" />
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import SettlementTypes from "../../../../staticData/TransportSettlementTypes";
import CurrencySelect from "../../../CustomInputComponents/CurrencySelect.vue";
import AmountInput from "../../../CustomInputComponents/AmountInput.vue";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowTransportSettlementLostTicketSet",
  components: { AmountInput, CurrencySelect },
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelAmount: {
      required: true
    },
    modelCurrency: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelCurrencyValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelAmountValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    contextAmount: {
      set: function(value) {
        this.$emit("update:modelAmount", value);
      },
      get: function() {
        return this.modelAmount;
      }
    },
    contextCurrency: {
      set: function(value) {
        this.$emit("update:modelCurrency", value);
      },
      get: function() {
        return this.modelCurrency;
      }
    }
  },
  methods: {
    settlementTypes: SettlementTypes
  }
};
</script>

<style scoped></style>
